import { useEffect, useState } from "react";
import ViewVideosSetel from "../views/home/ViewVideosSetel";
import { IOnboardDingPlaylistResponseField } from "~/lib/types/onboarding.videos.type";

export const SwiperComponent = ({
  videos,
  indexVideo,
}: {
  videos: IOnboardDingPlaylistResponseField[];
  indexVideo: number;
}) => {
  const [indexPlaylist, setIndexPlaylist] = useState<number>(indexVideo);
  const [indexCurrentVideo, setIndexCurrentVideo] = useState<number>(0);
  const [isShowPrev, setIsShowPrev] = useState<boolean>(true);
  const [isShowNext, setIsShowNext] = useState<boolean>(true);
  const playlistLength = videos.length;

  const videosLength = videos[indexPlaylist]?.videos.length;

  const indexCurrent = ({ prev }: { prev: boolean }) => {
    if (prev) {
      return indexCurrentVideo == 0 ? 0 : indexCurrentVideo - 1;
    } else {
      return indexCurrentVideo + 2 > videosLength
        ? indexCurrentVideo
        : indexCurrentVideo + 1;
    }
  };

  useEffect(() => {
    setIndexCurrentVideo(0); 
  }, [indexPlaylist]);

  useEffect(() => {
    if (indexCurrentVideo - 1 < 0 && indexPlaylist - 1 < 0) {
      setIsShowPrev(false);
    } else {
      setIsShowPrev(true);
    }
    if (
      indexCurrentVideo + 2 > videosLength &&
      indexPlaylist + 2 > playlistLength
    ) {
      setIsShowNext(false);
    } else {
      setIsShowNext(true);
    }
  }, [indexCurrentVideo, indexPlaylist]);

  return (
    <div data-testid="swiper" className="flex">
      {isShowPrev && (
        <div className="relative">
          <button
            onClick={() => {
              setIndexCurrentVideo(indexCurrent({ prev: true }));
              if (indexCurrentVideo == 0) {
                setIndexPlaylist((prevIndex) =>
                  prevIndex - 1 < 0 ? 0 : prevIndex - 1
                );
              }
            }}
            className="text-white z-100 chevron-left transform -translate-y-1/2"
          >
            <div className="ml-5 md:ml-10 h-10 w-10 rounded-[50%] flex justify-center items-center bg-black bg-opacity-50 border-none btn-close-image">
              <svg
                width="9"
                height="16"
                viewBox="0 0 9 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.53033 0.46967C8.26406 0.203403 7.8474 0.179197 7.55379 0.397052L7.46967 0.46967L0.46967 7.46967C0.203403 7.73594 0.179197 8.1526 0.397052 8.44621L0.46967 8.53033L7.46967 15.5303C7.76256 15.8232 8.23744 15.8232 8.53033 15.5303C8.7966 15.2641 8.8208 14.8474 8.60295 14.5538L8.53033 14.4697L2.061 8L8.53033 1.53033C8.7966 1.26406 8.8208 0.8474 8.60295 0.553788L8.53033 0.46967Z"
                  fill="white"
                />
              </svg>
            </div>
          </button>
        </div>
      )}

      <div className="grow w-full md:w-[40vw]">
        <div className="h-[80vh] m-auto">
          <ViewVideosSetel
            videosPlaylist={videos[indexPlaylist]}
            setIndexPlaylist={setIndexPlaylist}
            key={`${indexPlaylist}_${indexCurrentVideo}`}
            indexPlaylist={indexPlaylist}
            playlistLength={playlistLength}
            setIndexVideos={setIndexCurrentVideo}
            indexCurrentVideo={indexCurrentVideo}
          />
        </div>
      </div>

      {isShowNext && (
        <div className="relative">
          <button
            onClick={() => {
              setIndexCurrentVideo(indexCurrent({ prev: false }));
              if (indexCurrentVideo + 2 > videosLength) {
                setIndexPlaylist((prevIndex) =>
                  prevIndex + 2 > playlistLength
                    ? playlistLength - 1
                    : prevIndex + 1
                );
              }
            }}
            className="text-white z-100 chevron-right transform -translate-y-1/2"
          >
            <div className="mr-5 md:mr-10 h-10 w-10 rounded-[50%] icons-swiper flex justify-center items-center bg-black bg-opacity-50 border-none btn-close-image">
              <svg
                width="9"
                height="16"
                viewBox="0 0 9 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.46967 0.46967C0.735936 0.203403 1.1526 0.179197 1.44621 0.397052L1.53033 0.46967L8.53033 7.46967C8.7966 7.73594 8.8208 8.1526 8.60295 8.44621L8.53033 8.53033L1.53033 15.5303C1.23744 15.8232 0.762563 15.8232 0.46967 15.5303C0.203403 15.2641 0.179197 14.8474 0.397052 14.5538L0.46967 14.4697L6.939 8L0.46967 1.53033C0.203403 1.26406 0.179197 0.8474 0.397052 0.553788L0.46967 0.46967Z"
                  fill="white"
                />
              </svg>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};
